import { create } from 'zustand'
import { useShallow } from 'zustand/react/shallow'
import { type GeneratingImage } from '@/components/workspace/workspace-media/generating-media-preview'

// Extended type with workspaceId for the store
export interface GeneratingImageWithWorkspace extends GeneratingImage {
  workspaceId: number
}

type Store = {
  generatingImages: GeneratingImageWithWorkspace[]
  addGeneratingImage: (image: GeneratingImageWithWorkspace) => void
  removeGeneratingImage: (id: string) => void
  getGeneratingImagesForWorkspace: (workspaceId: number) => GeneratingImage[]
  clearGeneratingImagesForWorkspace: (workspaceId: number) => void
}

export const generatingImagesStore = create<Store>((set, get) => ({
  generatingImages: [],

  addGeneratingImage: (image) =>
    set((state) => ({
      generatingImages: [...state.generatingImages, image],
    })),

  removeGeneratingImage: (id) =>
    set((state) => ({
      generatingImages: state.generatingImages.filter((img) => img.id !== id),
    })),

  getGeneratingImagesForWorkspace: (workspaceId) =>
    get().generatingImages.filter((img) => img.workspaceId === workspaceId),

  clearGeneratingImagesForWorkspace: (workspaceId) =>
    set((state) => ({
      generatingImages: state.generatingImages.filter((img) => img.workspaceId !== workspaceId),
    })),
}))

export const useGeneratingImagesStore = () => {
  return generatingImagesStore(useShallow((s) => s))
}

// Hook to get generating images for a specific workspace
export const useGeneratingImagesForWorkspace = (workspaceId: number): GeneratingImage[] => {
  return generatingImagesStore(
    useShallow((s) => s.generatingImages.filter((img) => img.workspaceId === workspaceId)),
  )
}
